import React, { useState } from 'react'
import { Checkbox, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useHistory } from '@fs/zion-router'
import { useQueryParams } from '../../../../util/UrlUtil'
import { navigationQueryParams } from '../useMessagesListController'

const CATEGORY_OPTIONS = ['FAMILY_TREE', 'CET', 'SECONDARY']

export default function TreeCategories({ setQueueState }) {
  const queryParams = useQueryParams()
  const [selected, setSelected] = useState(() => queryParams?.get('treeCategories')?.split(',') || [])
  const history = useHistory()

  const { t } = useTranslation()

  const handleCheckboxChange = (value) => {
    const newTreeCategories = selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]
    setSelected(newTreeCategories)
    setQueueState((prev) => ({
      ...prev,
      treeCategories: newTreeCategories,
    }))
    history.replace({
      search: navigationQueryParams({
        queuePageIndex: queryParams.get('queuePageIndex'),
        personId: queryParams.get('personId'),
        treeCategories: newTreeCategories,
      }),
    })
  }

  return (
    <Row wrap>
      {CATEGORY_OPTIONS.map((category) => (
        <Checkbox
          key={category}
          label={t(`treeCategories.${category}`, category)}
          name={category}
          checked={selected.includes(category)}
          onChange={() => handleCheckboxChange(category)}
        />
      ))}
    </Row>
  )
}
